<template>
  <header>
    <div class="nav-header">
      <div class="nav-header__inner">
        <div class="nav-header__inner__logo" @click="toggleCollapse">
          <router-link to="/">
            <img :src="MvmntLogo" alt="stegi.radio logo" />
          </router-link>
        </div>
        <div class="nav-header__inner__left">
          <button v-b-toggle="searchCollapseId" class="search-button">
            <SearchIcon v-if="!searchCollapseIsOpen" />
            <IconClose v-else />
          </button>
          <ul class="nav-list">
            <li
              v-for="route in configRoutes.navRoutes"
              :key="route.id"
              class="nav-list__item"
              @click="toggleCollapse"
            >
              <router-link :to="{ path: route.routePath }" class="nav-list__item__link">
                {{ route.routeName }}
              </router-link>
            </li>
          </ul>
        </div>
        <div class="nav-header__inner__right">
          <a href="https://www.onassis.org/" target="_blank">
            <img class="logo-onassis"
                 :src="OnassisLogo"
                 alt="onassis logo"
            />
          </a>
          <button v-b-toggle="mobileNavcollapseId" class="burger-icon">
            <img class="collapsed-state"
                 :src="Burger"
                 alt=""
            />
            <img class="not-collapsed-state"
                 :src="BurgerClose"
                 alt=""
            />
          </button>
        </div>
      </div>
    </div>
    <AppNavCollapse :collapse-id="mobileNavcollapseId" @trigger-collapse="toggleCollapse" />
    <AppSearchCollapse :search-collapse-state="searchCollapseIsOpen" :collapse-id="searchCollapseId" />
  </header>
</template>
<script>
import configRoutes from '../../router/configRoutes';
import AppNavCollapse from '@/components/header/AppNavCollapse.vue';
import AppSearchCollapse from '@/components/header/AppSearchCollapse.vue';
import MvmntLogo from '@/assets/logos/stegi-radio-logo.svg';
import OnassisLogo from '@/assets/logos/onassis-inline-black.svg';
import Burger from '@/assets/icons/svg/burger.svg';
import BurgerClose from '@/assets/icons/svg/burger-close.svg';
import SearchIcon from '@/components/svg/SearchIcon.vue';
import IconClose from '@/components/svg/IconClose.vue';

export default {
  name: 'AppNav',
  components: {
    AppNavCollapse,
    AppSearchCollapse,
    SearchIcon,
    IconClose
  },
  data() {
    return {
      configRoutes: configRoutes,
      OnassisLogo: OnassisLogo,
      Burger: Burger,
      BurgerClose: BurgerClose,
      MvmntLogo: MvmntLogo,
      mobileNavcollapseId: 'collapse-mobile',
      searchCollapseId: 'collapse-search',
      locationsListCollapseId: 'location-index-collapse',
      locationsListCollapseShown: false,
      collapseIsOpen: false,
      searchCollapseIsOpen: false
    };
  },

  mounted() {
    this.$root.$on('bv::collapse::state', (collapseId, isJustShown) => {
      if (collapseId === this.mobileNavcollapseId) {
        this.collapseIsOpen = isJustShown;
        if (isJustShown) {
          // eslint-disable-next-line vue/custom-event-name-casing
          if (this.searchCollapseIsOpen) this.$root.$emit('bv::toggle::collapse', this.searchCollapseId);
          this.$store.commit('setLiveStreamInfoState', false);
        }
      }
      if (collapseId === this.searchCollapseId) {
        this.searchCollapseIsOpen = isJustShown;
        if (isJustShown) {
          // eslint-disable-next-line vue/custom-event-name-casing
          if (this.collapseIsOpen) this.$root.$emit('bv::toggle::collapse', this.mobileNavcollapseId);
          this.$store.commit('setLiveStreamInfoState', false);
        }
      }
      if (collapseId === this.locationsListCollapseId) {
        this.locationsListCollapseShown = isJustShown;
        // if (isJustShown) {
        //   // eslint-disable-next-line vue/custom-event-name-casing
        //   if (this.collapseIsOpen) this.$root.$emit('bv::toggle::collapse', this.mobileNavcollapseId);
        //   this.$store.commit('setLiveStreamInfoState', false);
        // }
      }
    });
  },

  methods: {
    toggleCollapse() {
      if (this.collapseIsOpen) {
        // eslint-disable-next-line vue/custom-event-name-casing
        this.$root.$emit('bv::toggle::collapse', this.mobileNavcollapseId);
      }
      if (this.locationsListCollapseShown) {
        // eslint-disable-next-line vue/custom-event-name-casing
        // this.$root.$emit('bv::toggle::collapse', this.locationsListCollapseId);
      }
    }
  }
};
</script>
<style scoped lang="scss">
@import '@/assets/sass/components/_nav-main.scss';
</style>
